import * as React from 'react';
import { Countdown } from 'components/Countdown';
import { withInjectedRootStore, RootStore } from 'providers';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import { Country } from 'enums';
import s from './SaleBanner.scss';
import dayjs from 'dayjs';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';

interface LastDaySaleBannerContentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const LastDaySaleBannerContentComp: React.FunctionComponent<
  LastDaySaleBannerContentProps
> = ({ rootStore, experiments }) => {
  const { country } = rootStore.appStore.appContext;
  const { saleEndDate, currentDateUtc, discountPercent } =
    rootStore.appStore.appContext.saleParams;

  let endDate = saleEndDate;
  if (country === Country.USA || country === Country.CA) {
    endDate = +dayjs(endDate).subtract(1, 'minute');
  }

  const lastDayTextKey = 'sale.banner.last_day_countdown';

  return (
    <Box
      dataHook='last-day-sale-banner-content'
      className={s.lastDaySaleBannerContent}
      align='center'
      verticalAlign='bottom'
    >
      <Text
        dataHook='last-day-sale-text'
        className={s.lastDaySaleText}
        size='small'
      >
        <Trans
          i18nKey={lastDayTextKey}
          values={{ percent: discountPercent || '50' }}
        >
          <span className={s.saleDiscount}>
            Save {{ percent: discountPercent || '50' }}%
          </span>
          rest
        </Trans>
      </Text>

      {endDate && (
        <Countdown
          currentDate={currentDateUtc}
          endDate={endDate}
          classNames={{
            wrapper: s.countdown,
            timePart: s.countdownTimePart,
            label: s.countdownTimePartLabel,
            separator: s.countdownSeparator,
            timePartWrapper: s.countdownTimePartWrapper,
          }}
        />
      )}
    </Box>
  );
};

export const LastDaySaleBannerContent = withInjectedRootStore(
  withExperiments(LastDaySaleBannerContentComp),
);
